import React from 'react';
import ProductComparison from './components/ProductComparison';

class App extends React.Component {

  render() {
    return (
      <ProductComparison />
    );
  }
}

export default App;
